import HttpClient from '@/common/boot/HttpClient'

// const salvarUsuario = async ({ commit }, payload) => {

//   commit('BUSCANDO', true);

//   return await HttpClient.post('/app/perfis', payload).then(response => {
//     commit('INSERIR_USUARIO', response.data.data)
//     return response;
//   })
//   .finally( () => {
//     commit('BUSCANDO', false);
//   });
// }

// const recuperarUsuario = ({ commit, state }, payload) => {

//   const usuario = state.items.filter(usuario => usuario.id === payload.id)

//   if(usuario.length) {
//     commit('INSERIR_USUARIO_SELECIONADO', ...usuario)
//     return true
//   }

//   return false
// }

// const atualizarUsuario = async ({ commit }, payload) => {
//   commit('BUSCANDO', true);

//   return await HttpClient.put(`/app/perfis/${payload.id}`, payload).then(response => {
//     commit('ATUALIZAR_USUARIO', payload)
//     return response;
//   })
//   .finally( () => {
//     commit('BUSCANDO', false);
//   })
// }

// const deletarUsuario = async ({ commit }, payload) => {
//   commit('BUSCANDO', true);

//   return await HttpClient.delete(`/app/perfis/${payload.id}`).then(response => {
//     commit('DELETAR_USUARIO', payload)
//     return response;
//   })
//   .finally( () => {
//     commit('BUSCANDO', false);
//   })

// }

const listarMenus = async ({commit}) => {
  commit('BUSCANDO', true);

  return await HttpClient.get(`/menus`).then(response => {
    commit('INSERIR_LISTA_MENUS', response.data.data)
    return response;
  })
  .finally( () => {
    commit('BUSCANDO', false);
  })
}

// const recuperarPerfilComMenus = async ({ commit }, payload) => {
//   commit('BUSCANDO', true);

//   return await HttpClient.get(`/app/perfis/${payload}/associar-menus`, payload).then(response => {
//     commit('INSERIR_USUARIO_SELECIONADO', response.data.data)
//     return response;
//   })
//   .finally( () => {
//     commit('BUSCANDO', false);
//   });
// }

const associarMenuAoPerfil = ({ commit }, payload) => {
  commit('BUSCANDO', true);

  HttpClient.post(`/roles/${payload.perfilId}/menus/sincronizar`, payload).then(response => {
    return response;
  })
  .finally( () => {
    commit('BUSCANDO', false);
  });
}

const listarMenusPorPerfis = async ({commit}, payload) => {
  commit('BUSCANDO', true);

  return await HttpClient.get(`/roles/${payload}/menus`).then(response => {
    commit('LISTA_MENUS_X_PERFIS', response.data.data.menus)
    commit('INSERIR_PERFIL_SELECIONADO', response.data.data.role)
    return response;
  })
  .finally( () => {
    commit('BUSCANDO', false);
  })
}

export {
  // salvarUsuario,
  // recuperarUsuario,
  // atualizarUsuario,
  // deletarUsuario,
  listarMenus,
  // recuperarPerfilComMenus,
  associarMenuAoPerfil,
  listarMenusPorPerfis
}